module.exports = __webpack_public_path__ + "img/laying-diagonale-on.37f770e2.svg";